import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Welcome from "./Welcome/Welcome";
import Home from "./Home/Home";
import Login from "./Login/Login";
import Report from "./Report/Report";
import Header from "./Header/Header";
import Social from "./Social/Social";
import GeoData from "./GeoData/GeoData";
import Manteca from "./Manteca/Manteca";
import Roseville from "./Roseville/Roseville";
import ElkGrove from "./ElkGrove/ElkGrove";
import Growth_Prediction from "./Growth Prediction/Growth_prediction";
import ResetPassword from "./resetPassword/resetPassword";
import ConfirmPassword from "./ConfirmPassword/ConfirmPassword";
import Teammates from "./Teammates/Teammates";

const Routing = (props: any) => {
  return (
    <Router>
      {props?.state?.isAuthenticated ? (
        <>
          <Header />
          <Routes>
            <Route path="/" element={<Welcome />}></Route>
            <Route path="/home" element={<Home />}></Route>
            <Route path="/report" element={<Report />}></Route>
            <Route path="/social" element={<Social />}></Route>
            <Route path="/geo" element={<GeoData />}></Route>
            <Route path="/geo/manteca-ca" element={<Manteca />}></Route>
            <Route path="/geo/roseville-ca" element={<Roseville />}></Route>
            <Route path="/geo/elk-grove-ca" element={<ElkGrove />}></Route>
            <Route path="/growthPrediction" element={<Growth_Prediction />}></Route>
            <Route path="/users" element={<Teammates />}></Route>
            
            <Route path="*" element={<Navigate to="/"></Navigate>}></Route>
            <Route path="/reset-password" element={<ConfirmPassword />}></Route> 
            <Route path="/reset-password/:token" element={<ConfirmPassword />}></Route>
          </Routes>
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<Login />}></Route>
          <Route path="*" element={<Navigate to="/login"></Navigate>}></Route>
          <Route path="/resetPassword" element={<ResetPassword />}></Route>
          <Route path="/reset-password" element={<ConfirmPassword />}></Route>
          <Route path="/reset-password/:token" element={<ConfirmPassword />}></Route>
         
        </Routes>
      )}
    </Router>
  );
};

export default Routing;